<template>
    <a-spin :spinning="loadingType">
    <div class="search-equals" style="display: flex;align-items: center;margin-top: 8px;">

        <label style="vertical-align:middle;" >MBOL:</label>
        <a-input-search 
            v-model:value="bill_search" 
            placeholder="Search" 
            @search="searchMbolHanlde"  
            style="vertical-align:middle;margin-left:20px;width:240px" allowClear />
    </div>
    
    <a-table :dataSource="dataSource" :columns="columns_info" style="margin-top: 8px;" :pagination="pageData"  @change="tableChangeHandle">
        <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'actions'">
                <template v-if="record.status !== 'Draft'">
                    <a v-if="record.aiScanStatus === 'Scanned' && record.status === 'Approved'" @click="checkHtsHandle(record)">Check</a>
                    <lable style="color: gray; cursor: not-allowed;" v-else>Check</lable>
                    <a-divider type="vertical"></a-divider>
                    <a v-if="record.status === 'Approved' " href="javascript:void(0)" @click="sendToCC(record)">Send</a>
                    <label v-else style="color: gray; cursor: not-allowed;">Send</label>
                    <a-divider type="vertical"></a-divider>
                    <a-dropdown :trigger="['click']" >
                        <a class='ant-dropdown-link' @click.prevent>
                            Download
                        </a>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item key='1'>
                                    <a href="javascript:void(0)" @click="downloadFileHandle('T86', record)">T86</a>
                                </a-menu-item>
                                <a-menu-item key='2'>
                                    <a  href="javascript:void(0)" @click="downloadFileHandle('ISF', record)">ISF</a>
                                </a-menu-item>
                                <a-menu-item  key='3'>
                                    <a v-if="record.transportMode==='OCEAN'" href="javascript:void(0)" @click="downloadFileHandle('AMS', record)">AMS</a>
                                    <a v-else href="javascript:void(0)" @click="downloadFileHandle('ACAS', record)">ACAS</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a  href="javascript:void(0)" @click="downloadFileHandle('T86V2', record)">Ocean T86 V2</a>
                                </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </template>
            </template>
            <template v-else-if="column.key === 'status'" >
                <a-tag  v-if="record.status === 'Draft'" color="red">{{ record.status }}</a-tag>
                <a-tag  v-else-if="record.status === 'Approved'" color="green">{{ record.status }}</a-tag>
                <a-tag v-else-if="record.status === 'Uploading'" color='processing'>{{ record.status }}</a-tag>
                <a-tag  v-else color="green">{{ record.status }}</a-tag>
            </template>
            <template v-else-if="column.key === 'masterBillNumber' ">
                {{ record.masterBillNumber }}<CopyOutlined  @click="copyMbolHandle(record.masterBillNumber)" style="margin-left: 8px;color: #1677ff"/>
            </template>
            <template v-else-if="column.key === 'firstLogisticsProviderName'"> 
                <label>{{ record.firstLogisticsProviderName }}</label>
            </template>
            
        </template>
    </a-table>
    </a-spin>
    
</template>
<script lang="ts">

import Api from '@/api/Api'
import router from '@/router'
import { message } from 'ant-design-vue'
import { defineComponent, nextTick, onMounted, reactive, ref } from 'vue'
import { CopyOutlined } from "@ant-design/icons-vue"
import { getCache } from '@/common/storage'

export default defineComponent({
    name: 'T86',
    components: {
        CopyOutlined,
    },
   
    setup(props, { emit }) {

        const loadingType = ref(false)
        let userInfo = getCache('userInfo')
        
        let username = userInfo.userName

        const dataSource : any = ref([])
        const bill_search = ref('')

        const pageData = ref({
            current : 1,
            pageSize : 10,
            total: 0,
            showSizeChanger: false,
            showQuickJumper: false
        })

        const searchMbolHanlde = () =>{
            pageData.value.current = 1
            getT86Data()
            
        }

        const checkHtsHandle = (item : any ) => {    
            router.push({
                name: 't86info',
                query: {
                    mainId: item.mainId,
                    masterBillNumber : item.masterBillNumber,
                }
            })
        }

        const getT86Data = async( params : any = {})=> {
            
            emit('custom-event', true)
            if( bill_search.value != null ){
                params.masterBillNumber = bill_search.value
            }

            if( pageData.value ){
                params.pageSize = pageData.value.pageSize
                params.pageNum = pageData.value.current
            }

            let response_data = await Api.getT86(params)
            
            emit('custom-event', false)
            if( response_data.code != 200 && response_data.code != 401) {
                message.error(response_data.msg)
                return 
            }
            dataSource.value = []
            if( response_data.total  > 0 ){
                pageData.value.total = response_data.total
            }
            for( let i = 0; i < response_data.rows.length; i++){
                response_data.rows[i].index = i + 1
                response_data.rows[i].estimateTimeOfDeparture = formatDate(response_data.rows[i].estimateTimeOfDeparture)
                dataSource.value.push(response_data.rows[i])
            }
        }

        const downloadFileHandle = async(type: string, record : any) =>{
            console.log("get profile", record, type)
            let loading = message.loading('Apply For Serve',100)
            
            let result = await Api.getClreanceProfile(record.masterBillNumber, type)
            if( result == "Download Succ"){
                loading()
                message.success("Loaded", 3)
            }else{
                console.log("download error ", result)
                loading()
                message.error(result, 3)
            }
           
        }
        const copyMbolHandle = async( mbol : string ) =>{
            await navigator.clipboard.writeText(mbol);
            message.success("Copy Succ", 2)
        }

        const tableChangeHandle = async(pagination : any) =>{
            //console.log("table change ")
            if( pageData.value.current == pagination.current && pageData.value.pageSize == pagination.pageSize){
                return
            }else{
                
                pageData.value.current = pagination.current
                pageData.value.pageSize = pagination.pageSize
                getT86Data()
            }
        }
        
        onMounted(()=>{
            nextTick(()=>{
                getT86Data()
            })
        })

        const formatDate = (datestr: string)=>{
            let month = datestr.slice(0,2)
            let day = datestr.slice(2,4)
            let year = datestr.slice(4,8)
            return year + '-' + month + '-' + day
            
        }
        const sendToCC = async( item : any) =>{
            console.log(item)
            let data = await Api.sentTOCC(item.mainId)
            console.log("send over", data)
            if( data && data?.code === 200 ){
                message.success("Sending Succ", 2)
                getT86Data()
            }else{
                emit('custom-event', false)
                message.error("Send To CC Fail", 2)
            }
        }

        const columns_info = [
            {title:'MBOL', dataIndex:'masterBillNumber', key:'masterBillNumber', fixed: 'left'},
            {title: 'Manifest Quantity', dataIndex : 'totalHouseCount', key: 'totalHouseCount'},
            {title: 'Item Quantity', dataIndex: 'totalShipmentQuantity', key: 'totalShipmentQuantity'},
            {title:'Origin Carrier', dataIndex:'firstLogisticsProviderName', key:'firstLogisticsProviderName', width : "200px"},
            {title:'PGA Summary', dataIndex:'pgaSummary', key:'pgasummary'},
            {title:'Status', dataIndex:'status', key:'status'},
            {title:'ETD', dataIndex:'estimateTimeOfDeparture', key:'estimateTimeOfDeparture'},
            {title:'Submit Time', dataIndex:'updateTime', key:'updateTime'},
            {title:'Action',  key:'actions', fixed: 'right'},            
        ]

        return {
            columns_info,
            dataSource,
            checkHtsHandle,
            searchMbolHanlde,
            bill_search,
            downloadFileHandle,
            copyMbolHandle,
            loadingType,
            pageData,
            tableChangeHandle,
            username,
            message,
            sendToCC
        }
    },
})
</script>

